import { render, staticRenderFns } from "./CompaniesTable.vue?vue&type=template&id=a21d7d34&scoped=true&"
import script from "./CompaniesTable.vue?vue&type=script&lang=ts&"
export * from "./CompaniesTable.vue?vue&type=script&lang=ts&"
import style0 from "./CompaniesTable.vue?vue&type=style&index=0&id=a21d7d34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21d7d34",
  null
  
)

export default component.exports